import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { color } from '../../templates/Ui';
const StyledMenuTitle = styled.h3 `
    margin: 0 0 5px 25px;
    text-transform: uppercase;
    color: ${color.gray.base};
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
`;
const MenuTitle = ({ children }) => (_jsx(StyledMenuTitle, { children: children }));
export default MenuTitle;
